import React, { useEffect, useState } from 'react';
import IpcPage from 'src/pages/MaestrosPage/IpcPage';
import ipciccService from 'src/services/ipciccService';
import swal from 'sweetalert';
import { swalMessages } from 'src/constants';

const IpcContainer = () => {
  const [ipc, setIpc] = useState({});
  const [loading, setLoading] = useState(false);
  const [icc, setIcc] = useState({});
  const [updateIpc, setUpdateIpc] = useState({
    variacion: '',
    indice: '',
    valor: '',
  });

  const reloadIpc = async () => {
    const response = await ipciccService.getIpc();
    if (response) {
      setIpc(response);
    }
    setLoading(false);
  };

  const reloadIcc = async () => {
    const response = await ipciccService.getICC();
    if (response) {
      setIcc(response);
    }
  };

  const handleChangeIpc = (type, event) => {
    setUpdateIpc({ ...updateIpc, [type]: event });
  };

  const handleUpdateIpc = async () => {
    const response = await ipciccService.updateIpc(updateIpc);
    if (response) {
      setLoading(true);
      swal(swalMessages.SUCCESSFUL_MESSAGE);
    } else {
      swal(swalMessages.WARNING_GENERAL);
    }
    setLoading(false);
  };

  const handleUpdateIcc = async () => {
    const response = await ipciccService.updateICC(updateIpc);
    if (response) {
      setLoading(true);
      swal(swalMessages.SUCCESSFUL_MESSAGE);
    } else {
      swal(swalMessages.WARNING_GENERAL);
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(false);
    reloadIpc();
    reloadIcc();
  }, [loading]);

  return (
    <IpcPage
      ipc={ipc}
      icc={icc}
      loading={loading}
      updateIpc={updateIpc}
      onUpdateIpc={handleUpdateIpc}
      onUpdateIcc={handleUpdateIcc}
      handleChangeIpc={handleChangeIpc}
    />
  );
};

export default IpcContainer;
